exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile__image[data-v-1559e7c3] {\n  border-radius: 50%;\n  width: 45px;\n  margin: 7.5px 7.5px 7.5px 0;\n}\n", ""]);

// exports
